export const setDocumentTitle = (title) => {
    document.title = title;
};
const metaDescriptionTag = document.head.querySelector('meta[name="description"]');
export const setMetaDescription = (description) => {
    if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute('content', description);
    }
};
const canonicalTag = document.head.querySelector('link[rel="canonical"]');
export const setCanonicalUrl = (url) => {
    if (canonicalTag) {
        canonicalTag.setAttribute('href', url.replace(/\/$/, ''));
    }
};
export const setAlternateUrl = (lang, url) => {
    const alternateTag = document.head.querySelector(`link[hreflang="${lang}"]`);
    if (alternateTag) {
        alternateTag.setAttribute('href', url);
    }
};
